import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {reportWebVitals} from './utils/index';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/index.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
reportWebVitals();
